import { Accordion } from '@components/atoms'
import { CheckboxFilterGroup, ColorFilterGroup } from '@components/molecules'
import { AttributeItemType, FilterValueType, ListingItemtype } from '@utils/types'
import { useTrans } from '../../../hooks'
import styles from './ListingFilters.module.sass'

interface Props {
  item: ListingItemtype
  className?: string
  filters?: FilterValueType[]
  setFilters?: (filters: FilterValueType[]) => void
}

const ListingFilters = (props: Props) => {
  const { item = undefined, className = '', filters = [], setFilters = undefined } = props

  const t = useTrans()

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <p className={styles.title}>{t('Filtra per:')}</p>
      <div className={styles.list}>
        {item.attributi?.length > 0 &&
          item.attributi.map((attr: AttributeItemType, i) => (
            <Accordion
              variant="filter"
              key={i}
              id={attr.chiave}
              label={attr?.label}
              className={styles.accordion}
            >
              {attr.chiave === 'colore' ? (
                <ColorFilterGroup attributo={attr} filters={filters} setFilters={setFilters} />
              ) : (
                <CheckboxFilterGroup attributo={attr} filters={filters} setFilters={setFilters} />
              )}
            </Accordion>
          ))}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ListingFilters
